import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { PopupWrapper } from "~/components/Popup/Popup"
import { Raw } from "~/components/raw"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import { PopupContent } from "./components/PopupContent/PopupContent"
import styles from "./index.module.css"

export const List: React.FC = () => {
  const list = useApiContext("/index/list")
  const { t } = useTranslation()

  return (
    <Wrapper>
      <div className="container">
        {list.map(({ name, link, logo, facts, description }) => (
          <PopupWrapper
            key={name}
            button={
              <div className={styles.Item}>
                <div className={styles.Heading}>
                  <Heading className={styles.Title} like="h2">
                    <Raw html={name} />
                  </Heading>

                  <Link className={styles.HeadingLink} view="arrow">
                    <Raw html={t("indexes-and-ratings.List.Card.Link")} />
                  </Link>
                </div>

                <div className={styles.Logo}>{logo && <img src={logo} />}</div>

                <div className={styles.Description}>
                  {facts.map(({ name, text }) => (
                    <p key={name}>
                      <span className={styles.Fact}>
                        <Raw html={name} />
                      </span>
                      <Raw html={text} />
                    </p>
                  ))}
                </div>

                <Link className={styles.FooterLink} href={link} view="arrow">
                  <Raw html={t("indexes-and-ratings.List.Card.Link")} />
                </Link>
              </div>
            }
            content={() => <PopupContent {...{ name, link, description }} />}
          />
        ))}
      </div>
    </Wrapper>
  )
}
